import { render } from "./TindaklanjutAduanMasyarakat.vue?vue&type=template&id=29af203d"
import script from "./TindaklanjutAduanMasyarakat.vue?vue&type=script&lang=js"
export * from "./TindaklanjutAduanMasyarakat.vue?vue&type=script&lang=js"

import "./TindaklanjutAduanMasyarakat.vue?vue&type=style&index=0&id=29af203d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__